import React, { Component } from "react";

import {
  // CCollapse,
  CListGroup,
  CListGroupItem,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import { log } from "../../../utils/log";
import TrailByActivities from "../TrailByActivities";
import TrailByStudent from "../TrailByStudent";

class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "Estatísticas por atividade"
    };
  }

  createLog() {
    log(
      "access",
      this.props.currentRoute,
      `Acessou as estatísticas da trilha ${this.props.trailName}`,
      this.props.trailId,
      this.props.user.token,
      null,
      this.props.general.active_roles.school_id || null
    );
  }

  getMenus() {
    return [
      {
        name: "Estatísticas por atividade",
        component: <TrailByActivities id={this.props.trailId} />
      },
      {
        name: "Estatísticas do estudante",
        component: <TrailByStudent id={this.props.trailId} />
      }
    ];
  }

  render() {
    return (
      <CModal
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>
            Estatísticas da trilha - {this.props.trailName}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <CListGroup
            style={{
              height: "100%",
              backgroundColor:
                "#f6f8f9" /* , borderRight:"1px solid rgba(0, 0, 21, 0.125)" */
            }}
          >
            {this.getMenus()
              .filter(menu => !menu.hideMenu)
              .map((menu, index) => (
                <React.Fragment key={index}>
                  <CListGroupItem
                    action
                    active={menu.name === this.state.menu}
                    style={{
                      border: "0",
                      borderRadius: "0",
                      minWidth: "250px"
                    }}
                    className="cursor"
                    onClick={() => this.setState({ menu: menu.name })}
                  >
                    {menu.name}
                  </CListGroupItem>
                </React.Fragment>
              ))}
          </CListGroup>
          <div
            className="p-3 charts flex-1 d-flex flex-column align-items-center"
            style={{ overflow: "auto" }}
          >
            <span className="est-text mb-3">
              <h1>{this.state.menu}</h1>
            </span>
            {
              this.getMenus().find(menu => menu.name === this.state.menu)
                .component
            }
          </div>
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);
